document.addEventListener("DOMContentLoaded", function () {
    const hero_banner = document.querySelectorAll(".hero_banner");
    hero_banner.forEach((section) => {
        const background_media_slider = section.querySelector(".background_media_slider");
        const customDotsWrapper = section.querySelector(".custom_dots");
        const background_media_slider_item = section.querySelectorAll(".background_media_slider_item");
        if (background_media_slider_item.length < 1) {
            const customDotsEl = section.querySelector(".content_sec__inner .custom_dots");
            if (customDotsEl) {
                customDotsEl.style.display = "none";
            }
        }

        if (background_media_slider) {
            const splidemediaslider = new Splide(background_media_slider, {
                type: "slide",
                perPage: 1,
                perMove: 1,
                pagination: true,
                arrows: false,
                speed: 1000,
                drag: false,
                rewind: true,
                autoplay: true,
                interval: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                classes: {
                    pagination: 'splide__pagination custom-pagination',
                },
            });

            splidemediaslider.on('mounted', function () {
                const pagination = background_media_slider.querySelector('.custom-pagination');
                if (pagination && customDotsWrapper) {
                    customDotsWrapper.appendChild(pagination);
                }
            });

            splidemediaslider.mount();
        }
    });
});